import React from "react";
import imagemLoadingSpinner from "../../assets/images/loading_spinner.gif";
export function LoadingIcon() {
    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%" }}>
            <img src={imagemLoadingSpinner} style={{ height: 50, width: 50 }} />
        </div>
    );
}
